export enum RedirectType {
  USER = 'User',
  DRIVER = 'Driver',
  BOOKING = 'Booking',
  FAVORITE = 'Favorite',
  PURCHASE = 'Purchase',
  ACTIVE_PASS = 'ActivePass',
  TRIP = 'Trip',
  MESSAGE = 'Message',
  SUGGESTION = 'Suggestion',
  OBSERVATION = 'Observation',
  SUGGESTION_COMMENT = 'SuggestionComment',
  OBSERVATION_COMMENT = 'ObservationComment',
  ROADMAP = 'Roadmap'
}
